import {
  IconAnalytics,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/retailOffice/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo3.mp4';

import image1 from '@src/assets/images/solution/retailMobile/img/1.avif';
import image2 from '@src/assets/images/solution/retailMobile/img/2.avif';
import image3 from '@src/assets/images/solution/retailMobile/img/3.avif';
import image4 from '@src/assets/images/solution/retailMobile/img/4.avif';
import image5 from '@src/assets/images/solution/retailMobile/img/5.avif';
import image6 from '@src/assets/images/solution/retailMobile/img/6.avif';
import image7 from '@src/assets/images/solution/retailMobile/img/7.avif';
import image8 from '@src/assets/images/solution/retailMobile/img/8.avif';
import { recommendationEdge, recommendationSwitch, retailMobile1, retailMobile2 } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '零售解决方案',
  banner: {
    title: '畅享智能手机体验，自动管理展示安全',
    desc: '通过无线标签技术，既能自由体验智能手机，又能自动维持展示安全。',
  },

  recommend: {
    title: '',
    desc: 'ORBRO OS 是一款强大的平台，用于实时定位追踪与智能监控。<br/>它完美集成了 BLE、UWB 以及基于 AI 的视频分析技术，为工业现场的安全性、效率与可扩展性而设计。',
    labels: {
      desktop: [
        {
          img: retailMobile1,
          data: recommendation.safeTag,
        },
        {
          img: retailMobile2,
          data: recommendation.safeCradle,
        },
        {
          img: recommendationEdge,
          data: recommendation.edgeRtls,
        },
        {
          img: recommendationSwitch,
          data: recommendation.switch,
        },
      ],
      mobile: [{ data: recommendation.safeTag }, { data: recommendation.safeCradle }, { data: recommendation.edgeRtls }, { data: recommendation.switch }],
    },
  },

  func: [
    {
      theme: '打造符合客户体验流程的智能展示环境',
      title: '自由体验的手机门店',
      desc: '顾客可自由拿起手机进行操作，无需束缚线即可保持安全，提供近似真实使用的体验。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '高精度定位',
      icon2: IconRulerGray,
      image: image1,
    },
    {
      title: '联动数码屏信息展示',
      desc: '顾客拿起设备时，其产品信息将自动显示在数码屏上，实现无导购情况下的自然信息获取。',
      sub1: '实时状态掌握',
      icon1: IconClockGray,
      sub2: '快速数据联动',
      icon2: IconShareGray,
      image: image2,
    },
    {
      title: '脱离监测及管理员警报',
      desc: '设备离开指定区域时，标签将发出警报并通知管理员，在不干扰体验的前提下立即响应安全事件。',
      sub1: '统计数据提供',
      icon1: IconChartBarGray,
      sub2: '数据云端保存',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: '通过体验数据分析热门设备',
      desc: '系统会自动记录设备被拿起次数与比较功能的使用记录，便于分析客户偏好并优化产品布局。',
      sub1: '统计数据提供',
      icon1: IconChartBarGray,
      sub2: '数据云端保存',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      theme: '展示专用标签与支架介绍',
      title: '无线标签实现自由体验',
      desc: 'Safe Tag 贴附于设备上，可供电并追踪位置，无需数据线即可保障安全，让顾客自由拿取体验产品。',
      sub1: '统计数据提供',
      icon1: IconChartBarGray,
      sub2: '数据云端保存',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: '兼容所有智能手机的通用设计',
      desc: 'Safe Tag 可适配大多数品牌和型号的手机，统一展示方式，提升运营一致性与适用范围。',
      sub1: '统计数据提供',
      icon1: IconChartBarGray,
      sub2: '数据云端保存',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '实现展示与安防的专用支架',
      desc: '支架与标签精准贴合，稳定供电并可实时追踪设备位置，实现无线充电与区域安防的双重目标。',
      sub1: '统计数据提供',
      icon1: IconChartBarGray,
      sub2: '数据云端保存',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '符合人体工学的15度最佳支撑角度',
      desc: '支架设计为15度倾斜角度，便于顾客自然拿取与归位，确保稳定的展示体验流程。',
      sub1: '统计数据提供',
      icon1: IconChartBarGray,
      sub2: '数据云端保存',
      icon2: IconCloudCheckGray,
      image: image8,
    },
  ],

  subfunc: {
    title: '功能概览',
    desc: '实现高效库存管理、节省时间与成本、提高透明度与可追踪性。<br/>ORBRO 提供以下附加功能，助您打造最佳工作环境并提升效率。',
    data: [
      {
        icon: IconLayers,
        title: '无线标签展示结构',
        desc: '将标签贴附在展示物上，进行无线定位与状态监控。',
      },
      {
        icon: IconLocation,
        title: '基于距离的安防机制',
        desc: '监测标签与设备间的距离变化，一旦超出范围即触发警报。',
      },
      {
        icon: IconSearch,
        title: '一体式标签贴合设计',
        desc: '标签可紧密贴于设备底部，不影响外观美感。',
      },
      {
        icon: IconAnalytics,
        title: '越界自动报警通知',
        desc: '设备离开指定区域，标签发出警报并向管理员发送通知。',
      },
      {
        icon: IconChartBar,
        title: '实时定位与供电',
        desc: '展出期间保持供电并支持实时追踪，保障自由体验。',
      },
      {
        icon: IconRoute,
        title: '滑动铰链结构',
        desc: '根据充电口位置灵活调整，适配多种设备。',
      },
      {
        icon: IconRoute,
        title: '15度倾角支架设计',
        desc: '提供自然拿取与安放的支撑角度，符合人体工学。',
      },
      {
        icon: IconLayers,
        title: '无线充电展示环境',
        desc: '支架与标签均隐藏于展示物下方，打造整洁的展示空间，并实现稳定供电。',
      },
    ],
  },

  system: {
    title: '系统构成',
    img: rtlsSystem,
  },

  productTitle: '产品组成',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'logisticsAsset' }, { data: 'manufacturingSteel' }, { data: 'blogOffice' }, { data: 'blogRTLS' }],
};
